import {AfterViewInit, Component, ElementRef, NgZone, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {PaymentData} from 'src/app/models/application/payment-data.model';
import {CompletePaymentRequest} from 'src/app/models/request/complete-payment-request.model';
import {SessionService} from 'src/app/services/session.service';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {Router} from '@angular/router';
import {DialogService} from 'src/app/services/dialog.service';
import {PaymentService} from 'src/app/services/payment.service';
import {Complement} from 'src/app/models/application/complement.model';
import {PurchaseUnit} from 'src/app/models/application/purchase-unit.model';
import {ProductPaymentData} from 'src/app/models/application/product-payment-data.model';
import {DeviceDetectorService} from 'ngx-device-detector';
import {Meta, Title} from '@angular/platform-browser';

declare var paypal: any;

@Component({
    selector: 'app-payment',
    templateUrl: './payment.component.html',
    styleUrls: ['./payment.component.scss']
})
export class PaymentComponent implements OnInit, OnDestroy, AfterViewInit {
    @ViewChild('paypal', {static: true}) paypalElem: ElementRef;
    private userData: any;
    tranSelect: any;
    methodInfo: any;
    errorData: any;
    data: PaymentData;
    steps: any;
    totalItems = 0;
    productsList: PaymentData[] = [];
    paypalProducts: PurchaseUnit;
    paymentMethod: any;
    totalMonth = 0;
    totalAnnual = 0;
    complementsAdd = false;
    numtransaction: number[] = [10, 20, 50, 100, 200, 500, 1000];
    pricetransaction: number[] = [59.90, 99.90, 249.90, 449.90, 799.90, 1899.90, 3499.90];
    private ngUnsubscribe: Subject<any> = new Subject<any>();
    /* VARIABLES PARA SABER SI SON MOVILES */
    isMobile: any = false;
    isTablet: any = false;
    loader: boolean;
    countryVisit: any = false;

    constructor(
        private sessionService: SessionService,
        private dialogService: DialogService,
        private router: Router,
        private ngZone: NgZone,
        private paymentService: PaymentService,
        private deviceService: DeviceDetectorService,
        private metas: Meta,
        private titlePage: Title
    ) {
        this.isMobile = this.deviceService.isMobile();
        this.isTablet = this.deviceService.isTablet();
        const TITLE = 'Assinatura digital com validade jurídica | A única Assinatura Autógrafa Digital®';
        const DESCRIPTION = 'Descrição: FAD® é a única assinatura digital com patente internacional, equivalente funcional à assinatura em papel. Disponível para iOS e Android. Experimente Grátis!';
        const URL = 'https://www.assinaturaautografadigital.com.br/comprar-assinatura-digital';
        const IMG = 'https://hola.firmaautografa.com/hubfs/BRASIL-ASSETS/METAS-PLACE-BRASIL-PAGES/home.png';
        this.titlePage.setTitle(TITLE);
        /* PRINCIPALES */
        this.metas.updateTag({
            name: 'keywords',
            content: 'comprar firma digital'
        });
        this.metas.updateTag({
            name: 'description',
            content: DESCRIPTION
        });
        /* FACEBOOK Y LINKEDIN */
        this.metas.updateTag({
            property: 'og:url',
            content: URL
        });
        this.metas.updateTag({
            property: 'og:title',
            content: TITLE
        });
        this.metas.updateTag({
            property: 'og:description',
            content: DESCRIPTION
        });
        this.metas.updateTag({
            property: 'og:image',
            content: IMG
        });
        /* TWITTER */
        this.metas.updateTag({
            name: 'twitter:title',
            content: TITLE
        });
        this.metas.updateTag({
            name: 'twitter:description',
            content: DESCRIPTION
        });
        this.metas.updateTag({
            name: 'twitter:image',
            content: IMG
        });
        window.scrollTo(0, 0);
        this.userData = this.sessionService.getPaymentAccount();
        this.sessionService.genPaymentSteps();
        this.steps = this.sessionService.updateSteps();
        /* LOCALIZACION */
        this.sessionService.getLocationUser().subscribe(
            (response: any) => {
                if (response) {
                    this.sessionService.getCountrieUser(response.location.lat, response.location.lng).subscribe(
                        (responseCountrie: any) => {
                            this.sessionService.setCountryData(responseCountrie.results[responseCountrie.results.length - 2]
                                .formatted_address);
                            this.countryVisit = this.sessionService.getCountryData() === 'México';
                        }
                    );
                }
            }
        );
        this.sessionService.updateStepsListener$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(
            // tslint:disable-next-line:variable-name
            _next => {
                this.updateSteps();
                this.methodInfo = this.sessionService.getDataPay();
            }
        );
        this.sessionService.listenCartItems$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(
            // tslint:disable-next-line:variable-name
            _data => {
                this.totalItems = this.countCartItems();
                if (this.totalItems === 0) {
                    this.withoutProductsAction();
                }
                this.preparePaypal();
            }
        );
        this.totalItems = this.countCartItems();
        if (this.totalItems === 0) {
            this.withoutProductsAction();
        }
        this.preparePaypal();
    }

    ngOnInit(): void {
        this.sessionService.setPromoCode(null);
        if (this.productsList.length > 0) {
            this.productsList.forEach(product => {
                if (product.type === 'anual' && product.product === 'FAD® PESSOAL') {
                    this.tranSelect = Number(product.transactions);
                }
            });
        }

        onkeydown = ev => {
            if (ev.key === 'Tab') {
                return false;
            }
        };

    }

    payment(): void {
        this.loader = true;
        const request = new CompletePaymentRequest();
        const accountData = this.sessionService.getPaymentAccount();
        const billingData = this.sessionService.getPaymentBilling();
        request.user = {...accountData};
        request.currency = 'BRL';
        request.user.maxSigns = Number.parseInt(this.productsList[0].transactions, 10);
        request.user.username = accountData.user;
        request.user.isCompany = this.productsList[0].product !== 'FAD® PESSOAL';
        request.user.isRecurrentPlan = this.productsList[0].subscription === 'Assinatura mensal';
        request.user.countryCode = accountData.countryCode;
        if (this.sessionService.getPromoCode()) {
            request.couponId = this.sessionService.getPromoCode().couponId;
        }
        request.card = {
            // @ts-ignore
            number: this.sessionService.getDataPay().creditCard,
            // @ts-ignore
            expMonth: this.sessionService.getDataPay().expiration.split('/')[0],
            // @ts-ignore
            expYear: this.sessionService.getDataPay().expiration.split('/')[1],
            // @ts-ignore
            cvc: this.sessionService.getDataPay().cvv
        };
        request.idSourceSystem = 4;
        request.tokenConekta = null;
        request.products = this.setProductsInCart();
        request.tax = 0;
        request.language = 'pt';
        // tslint:disable-next-line:no-bitwise
        if (billingData.country === '' || billingData.country === null) {
            this.sessionService.setPaymentBilling(null);
            request.billing = {country: null, state: null, city: null, code: null, address: null, rfc: null, businessName: null};
        } else {
            request.billing = {...billingData};
        }
        this.paymentService.sendOrder(request).subscribe(
            responseSendOrder => {
                this.loader = false;
                // tslint:disable-next-line:max-line-length
                if (responseSendOrder.success) {
                    this.router.navigate(['/sucesso-compra-assinatura-digital']);
                    this.sessionService.setAccountData('USER_ACCOUNT');
                } else {
                    if (responseSendOrder.error === ('Your card was declined.')
                        || responseSendOrder.error === ('Your card has insufficient funds.')) {
                        this.errorData = 'Ocorreu um erro com o cartão, tente outro.';

                        if (billingData.country === '' || billingData.country === null) {
                            this.sessionService.setPaymentBilling({
                                country: null, state: null, city: null,
                                code: null, address: null, rfc: null, businessName: null
                            });
                        }

                    } else if (responseSendOrder.error.includes('No se pudo crear el usuario. Se agregaron')) {
                        this.router.navigate(['/sucesso-compra-assinatura-digital']);
                    } else if (responseSendOrder.error === ('No se pudo llenar el usuario.')) {
                        this.router.navigate(['/sucesso-compra-assinatura-digital']);
                    } else {
                        switch (responseSendOrder.error) {
                            case 'Your card number is incorrect.':
                                this.errorData = 'O número do cartão está errado, tente outro.';
                                break;
                            case 'Your card has expired.':
                                this.errorData = 'Seu cartão expirou, tente outro.';
                                break;
                            case 'invalid_expiry_year':
                                this.errorData = 'Acho que você errou no ano de validade.';
                                break;
                            case 'Your card does not support this type of purchase.':
                                this.errorData = 'A transação não pôde ser processada, revise os dados e tente novamente, lembre-se de usar o cartão digital para fazer compras mais seguras.';
                                break;
                            default:
                                this.errorData = 'Ocorreu um erro. Por favor tente novamente mais tarde.';
                                break;
                        }
                        if (billingData.country === '' || billingData.country === null) {
                            this.sessionService.setPaymentBilling({
                                country: null, state: null, city: null,
                                code: null, address: null, rfc: null, businessName: null
                            });
                        }

                    }
                }
            },
            () => {
                this.errorData = 'Ocorreu um erro. Por favor tente novamente mais tarde.';
            }
        );
    }

    ngAfterViewInit(): void {
    }

    setTransacciones(x: number, item: PaymentData): void {
        item.transactions = `${x}`;
        item.pricing = this.pricetransaction[this.numtransaction.indexOf(x)];
        this.removeDataLayerProduct(item);
        // @ts-ignore
        window.dataLayer = window.dataLayer || [];
        // @ts-ignore
        dataLayer.push({ecommerce: null});
        // @ts-ignore
        dataLayer.push({
            event: 'addToCart',
            ecommerce: {
                currencyCode: 'BRL',
                add: {                                // 'add' actionFieldObject measures.
                    products: [{                        //  adding a product to a shopping cart.
                        name: 'FAD® - Plano Pessoal - Pré-pago anual',                      // Name or ID is required.
                        id: 'FADPPPA' + item.transactions,
                        price: item.pricing,
                        brand: 'FAD®',
                        category: 'FAD® Pessoal',
                        variant: 'Anual ' + item.transactions,
                        position: 2
                    }]
                }, detail: {
                    name: 'FAD® - Plano Pessoal - Pré-pago anual',                      // Name or ID is required.
                    id: 'FADPPPA' + item.transactions,
                    price: item.pricing,
                    brand: 'FAD®',
                    category: 'FAD® Pessoal',
                    variant: 'Anual ' + item.transactions,
                    position: 2
                }
            }
        });
        this.justUpdate(item);
    }

    removeDataLayerProduct(item: any): any {
        // @ts-ignore
        window.dataLayer = window.dataLayer || [];
        // @ts-ignore
        dataLayer.push({ecommerce: null});
        if (item.product === 'FAD® PESSOAL') {
            if (item.type === 'month') {
                // @ts-ignore
                dataLayer.push({ecommerce: null});  // Clear the previous ecommerce object.
                // @ts-ignore
                dataLayer.push({
                    event: 'removeFromCart',
                    ecommerce: {
                        remove: {                               // 'remove' actionFieldObject measures.
                            products: [{                          //  removing a product to a shopping cart.
                                name: 'FAD® - Plano Pessoal - Plano Mensal',                   // Name or ID is required.
                                id: 'FADPPSM',
                                price: item.pricing,
                                brand: 'FAD®',
                                category: 'FAD® Pessoal',
                                variant: 'Assinaturas Ilimitadas',
                                position: 1
                            }]
                        }
                    }
                });
            } else {
                // @ts-ignore
                dataLayer.push({ecommerce: null});  // Clear the previous ecommerce object.
                // @ts-ignore
                dataLayer.push({
                    event: 'removeFromCart',
                    ecommerce: {
                        remove: {                               // 'remove' actionFieldObject measures.
                            products: [{                          //  removing a product to a shopping cart.
                                name: 'FAD® - Plano Pessoal - Pré-pago anual',                      // Name or ID is required.
                                id: 'FADPPPA' + item.transactions,
                                price: item.pricing,
                                brand: 'FAD®',
                                category: 'FAD® Pessoal',
                                variant: 'Anual ' + item.transactions,
                                position: 2
                            }]
                        }
                    }
                });
            }
        } else {
            // @ts-ignore
            dataLayer.push({ecommerce: null});  // Clear the previous ecommerce object.
            // @ts-ignore
            dataLayer.push({
                event: 'removeFromCart',
                ecommerce: {
                    remove: {                               // 'remove' actionFieldObject measures.
                        products: [{                          //  removing a product to a shopping cart.
                            name: 'FAD® - Plano Empresarial - Plano Mensal',
                            id: 'FADPESM',
                            price: '149,90',
                            brand: 'FAD®',
                            category: 'FAD® Pessoal',
                            variant: 'Assinaturas Ilimitadas',
                            position: 1
                        }]
                    }
                }
            });
        }
    }

    setProductsInCart(): ProductPaymentData[] {
        const productsData: ProductPaymentData[] = [];
        this.productsList.forEach(product => {
            const productTmp = new ProductPaymentData();
            productTmp.name = `${product.product} ${product.subscription}`;
            productTmp.price = (this.getTotalDescuento() === null ? product.pricing : this.getTotalDescuento()) * 100;
            productTmp.quantity = product.quantity;
            productTmp.suscriptionType = product.type === 'anual' ? 2 : 1;
            productsData.push(productTmp);
            product.complements.forEach(
                complement => {
                    const productComp = new ProductPaymentData();
                    if (complement.isAdd) {
                        productComp.name = complement.name;
                        productComp.price = complement.price * 100;
                        productComp.quantity = complement.quantity;
                        productComp.suscriptionType = 1;
                        productsData.push(productComp);
                        switch (complement.name) {
                            case 'Foto INE+Comparación de firma':
                                productComp.complements.ineFirma = true;
                                break;
                            case 'Foto INE':
                                productComp.complements.fotoINE = true;
                                break;
                            case 'Foto INE+Comparación de firma+comparación de videofirma vs foto INE':
                                productComp.complements.ineFirmaVideoFirma = true;
                                break;
                            case 'OTP vía WhatsApp':
                                productComp.complements.otpWhatsapp = true;
                                break;
                            case 'Versión WEB':
                                // productComp.complements
                                break;
                            case 'Foto INE+Comparación de firma+comparación de videoacuerdo vs foto INE':
                                productComp.complements.ineFirmaVideoAcuerdo = true;
                                break;
                            case 'Constancia de conservación en USA':
                                productComp.complements.constanciaUSA = true;
                                break;
                            case 'Foto INE+Comparación de firma+comparación de videoacuerdo y de videofirma vs foto INE':
                                // productComp.complements
                                break;
                            case 'Constancia de conservación en Blockchain (Etherium)':
                                productComp.complements.constanciaBlockChain = true;
                                break;
                        }
                    }
                }
            );
        });

        return productsData;
    }

    getItemTotal(item: PaymentData): number {
        let count = item.pricing;
        item.complements.forEach(complement => {
            if (complement.isAdd) {
                count += complement.price;
            }
        });
        return count;
    }

    preparePaypal(): void {
        setTimeout(() => {
            try {
                const parentNodeCard = document.getElementById('paypal-container-card') as HTMLElement;
                parentNodeCard.innerHTML = '';
                this.paypalProducts = new PurchaseUnit();
                this.productsList.forEach(product => {
                    this.paypalProducts.description = this.paypalProducts.description
                        + ' - ' + `${product.product} ${product.subscription}`;
                    this.paypalProducts.amount.value += this.getItemTotal(product);
                });
                this.paypalProducts.amount.currency_code = 'MXN';
                paypal.Buttons(
                    {
                        style: {
                            color: 'black'
                        },
                        createOrder: (data, actions) => {
                            return actions.order.create(
                                {
                                    purchase_units: [
                                        {...this.paypalProducts}
                                    ],
                                    application_context: {
                                        shipping_preference: 'NO_SHIPPING'
                                    }
                                }
                            );
                        },
                        onApprove: async (data, actions) => {
                            await actions.order.capture();
                            this.finishPayment(true);
                        },
                        onError: err => {
                            // tslint:disable-next-line:no-console
                            console.debug(err);
                        }
                    }
                )
                    .render(parentNodeCard);
            } catch (error) {
            }
        }, 500);
    }

    ngOnDestroy(): void {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }

    finishPayment(ngZone?: boolean): void {
        if (ngZone) {
            this.ngZone.run(() => this.router.navigate(['/sucesso-compra-assinatura-digital'])).then();
        } else {
            this.router.navigate(['/sucesso-compra-assinatura-digital']);
        }
    }

    withoutProductsAction(): void {
        this.dialogService.showNotificationDialog('Sem produtos', 'Você não tem produtos adicionados ao carrinho');
        this.router.navigate(['/']);
    }

    justUpdate(item: PaymentData): void {
        this.sessionService.updateCartList(item, false, null, true);
    }

    updateCart(item: PaymentData, isAdd?: boolean, num?: number, justUpdate?: boolean): void {
        this.sessionService.updateCartList(item, isAdd, num, justUpdate);
    }

    deleteItem(item: PaymentData): void {
        this.dialogService.showConfirmationDialog(
            'Confirme a operação',
            'Tem certeza de que deseja remover este produto do carrinho?',
            () => {
                this.updateCart(item);
                this.removeDataLayerProduct(item);
                this.sessionService.setPromoCode(null);
            }
        );
    }

    removeComplement(productIndex, complementIndex): void {
        this.dialogService.showConfirmationDialog(
            'Confirme a operação',
            '¿Estás seguro de remover este complemento?',
            () => {
                const item = this.productsList[productIndex];
                item.complements.forEach((com, i) => {
                    if (i === complementIndex) {
                        com.isAdd = false;
                        com.quantity = 1;
                    }
                });
                this.sessionService.updateCartList(item, false, null, true);
            }
        );
    }

    countCartItems(): number {
        let count = 0;
        let aux = 0;
        let diferentP = false;
        const items = this.sessionService.getCartItems();
        items.forEach(data => {
            count += data.quantity;
            data.complements.forEach(info => {
                if (info.isAdd) {
                    aux++;
                }
                if (aux === 0) {
                    this.complementsAdd = false;
                } else if (aux >= 1) {
                    this.complementsAdd = true;
                }
            });
        });
        if (this.userData === null) {
            this.productsList = [...items];
        } else {
            this.productsList = [...items];
            if (this.userData.isCompany) {
                this.productsList.forEach(
                    data => {
                        if (data.product === 'FAD® PESSOAL') {
                            this.updateCart(data);
                            diferentP = true;
                        }
                    }
                );
            } else {
                this.productsList.forEach(
                    data => {
                        if (data.product === 'FAD® EMPRESARIAL') {
                            this.updateCart(data);
                            diferentP = true;
                        }
                    }
                );
            }
        }
        if (diferentP) {
            this.dialogService.showNotificationDialog('Notificação', 'Produtos que não atendem ao seu perfil foram removidos.');
        }
        return count;
    }

    isComplete(): boolean {
        let res = true;
        Object.keys(this.steps).forEach(key => {
            if (this.steps[key].completed === false) {
                res = false;
            }
        });
        return res;
    }

    updateSteps(): void {
        this.steps = {...this.sessionService.updateSteps()};
        if (this.steps.accountStep.completed) {
            this.userData = this.sessionService.getPaymentAccount();
            this.countCartItems();
        }
    }

    someComplement(item: PaymentData): boolean {
        return item.complements.some(data => data.isAdd === true);
    }

    getIVA(total: any): any {
        return parseFloat(total).toFixed(2);
    }

    getTotalDescuento(): any {
        if (this.sessionService.getPromoCode()) {
            return parseFloat(String(this.sessionService.getPromoCode().amounts[0].amountAfterDiscount / 100)).toFixed(2);
        }
        return null;
    }

    getTotal(aux?: number): string {
        let total = 0;
        this.totalAnnual = 0;
        this.totalMonth = 0;
        // this.totalComplements = 0;
        const items = this.sessionService.getCartItems();
        items.forEach((data: PaymentData) => {
            total += data.pricing;
            if (data.type === 'month') {
                this.totalMonth += data.pricing;
            } else {
                this.totalAnnual += data.pricing;
            }
            data.complements.forEach((dataComplement: Complement) => {
                if (dataComplement.isAdd) {
                    if (data.type === 'month') {
                        this.totalMonth += dataComplement.price * dataComplement.quantity;
                    } else {
                        this.totalAnnual += dataComplement.price * dataComplement.quantity;
                    }
                    total += dataComplement.price * dataComplement.quantity;
                }
            });
        });
        if (aux === 1 && this.countryVisit) {
            total = Number.parseFloat(total.toString()) + Number.parseFloat(this.getIVA(total * 0.16));
        }
        return parseFloat(String(total)).toFixed(2);
    }

    getTotalIVA(total: any): any {
        if (this.getTotalDescuento() && this.countryVisit) {
            // tslint:disable-next-line:max-line-length
            const totalDescuento: number = Number(parseFloat(this.getTotalDescuento()).toFixed(2)) + Number(parseFloat(String(this.getTotalDescuento() * .16)).toFixed(2));
            return totalDescuento.toFixed(2);
        }
        return parseFloat(total).toFixed(2);
    }

    getPriceCentavos(price: number): any {
        return parseFloat(price.toString()).toFixed(2);
    }

    getTransacciones(data: PaymentData): string {
        switch (data.type) {
            case 'month':
                return ' Assinaturas ilimitadas ';
            case 'anual':
                return data.transactions + ' Assinaturas ';
        }
    }

}
